'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/hero.js';
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _themes = require('@marmalade/themes');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _propTypes = require('prop-types');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
Hero.propTypes = {
  title: _propTypes.node,
  children: _propTypes.node
};
var heroBodyStyles = function heroBodyStyles(_ref) {
  var theme = _ref.theme;
  return _defineProperty({
    display: 'flex'
  }, (0, _themes.between)(0, theme.breakpoint_sm), {
    alignItems: 'center',
    flexDirection: 'column-reverse'
  });
};
var HeroBody = (0, _glamorous2.default)('div')(heroBodyStyles);
function Hero(_ref3) {
  var title = _ref3.title,
    children = _ref3.children,
    rest = _objectWithoutProperties(_ref3, ['title', 'children']);
  return _react2.default.createElement(_glamorous.Section, Object.assign({}, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23
    },
    __self: this
  }), title, _react2.default.createElement(HeroBody, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25
    },
    __self: this
  }, children));
}
exports.default = Hero;